import React, { useState, useEffect } from "react";
import { Button } from "../../../components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/ui/table";
import { createUrl, get } from "../../../network/AxiosInterceptor";
import { Input } from "../../../components/ui/input";
import { Toaster } from "../../../components/ui/toaster";
import { useToast } from "../../../components/ui/use-toast";
import { useNavigate } from "react-router-dom";

const UsersListContainer = () => {
    const navigate = useNavigate();
  const { toast } = useToast();
  const [usersData, setUsersData] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    // Fetch user data from your NestJS server
    const fetchUsers = async () => {
      return get(createUrl(`/api/users/all`), {
        params: {
          offset: 0,
          limit: 100,
        },
      })
        .then((response) => {
          console.log(response);
          setUsersData(response.data.users);
        })
        .catch(function (error) {
          console.log(error);
        });
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    if (!usersData) {
      return;
    }
    const usersList = usersData.filter((user) => user != null);
    setUsers(usersList);
  }, [usersData]);

  const handleAddUser = () => {
    navigate(`/admin/users/edit`);
  };

  const handleEditUser = (user) => {
    const currUrl = window.location.pathname;
    navigate(`${currUrl}/edit/${user.id}`);
  };

  const handleDeleteUser = (user) => {
    toast({
      title: "Exploro",
      description: "Delete functionallity not supported",
      variant: "destructive",
    });
  };

  return (
    <div className="flex flex-col h-screen">
      <header className="flex h-14 items-center gap-4 border-b bg-gray-100/40 px-6 dark:bg-gray-800/40">
        <div className="w-full flex-1 flex items-center gap-4">
          <form>
            <div className="relative">
              <SearchIcon className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-500 dark:text-gray-400" />
              <Input
                className="bg-white shadow-none appearance-none pl-8 lg:w-64 w-full dark:bg-gray-950"
                placeholder="Search users..."
                type="search"
              />
            </div>
          </form>
          <div className="relative bg-white p-1 flex items-center">
            <FilterIcon className="absolute h-4 w-4 text-gray-500 dark:text-gray-400" />
            <select className="w-full  shadow-none appearance-none pl-8 md:w-2/3 lg:w-52 dark:bg-gray-950">
              <option value="">Filter by role</option>
              <option value="admin">Admin</option>
              <option value="user">User</option>
            </select>
          </div>
        </div>
      </header>
      <main className="flex flex-1 flex-col gap-4 p-4 md:gap-8 md:p-6">
        <div className="flex items-center justify-between">
          <h1 className="font-semibold text-lg md:text-2xl">Users</h1>
          <Button
            className="py-2 px-4 rounded-md"
            variant="solid onClick={handleAddUser}"
          >
            <PlusIcon className="h-4 w-4 mr-2" />
            Add New User
          </Button>
        </div>
        <div className="border shadow-sm rounded-lg">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-24 h-24">Image</TableHead>
                <TableHead className="w-96">Name</TableHead>
                <TableHead className="w-96">Email</TableHead>
                <TableHead className="w-36">Role</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {users.map((user, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <img
                      alt="User"
                      className="aspect-square rounded-md object-cover h-12 w-12"
                      src={user.profilePic}
                    />
                  </TableCell>
                  <TableCell className="font-medium">{user.fullName}</TableCell>
                  <TableCell className="">{user.email}</TableCell>
                  <TableCell className="">{user.role}</TableCell>
                  <TableCell>
                    <Button
                      className="mr-2"
                      size="icon"
                      variant="outline"
                      onClick={() => handleEditUser(user)}
                    >
                      <PencilIcon className="h-4 w-4" />
                      <span className="sr-only">Edit</span>
                    </Button>
                    <Button
                      size="icon"
                      variant="outline"
                      onClick={() => handleDeleteUser(user)}
                    >
                      <TrashIcon className="h-4 w-4" />
                      <span className="sr-only">Delete</span>
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </main>
      <Toaster />
    </div>
  );
};

function FilterIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
  );
}

function PencilIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
      <path d="m15 5 4 4" />
    </svg>
  );
}

function PlusIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12h14" />
      <path d="M12 5v14" />
    </svg>
  );
}

function SearchIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </svg>
  );
}

function TrashIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 6h18" />
      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
    </svg>
  );
}

export default UsersListContainer;
